import { useState } from "react";

const PORTFOLIO_ITEMS = [
  { id: "1", title: "Astral Healing Retreat 2025", category: "Events", icon: "🔮", desc: "Over 200 seekers gathered at The Grand Oaks Resort for three days of deep transformation." },
  { id: "2", title: "Hanuman Healing Sessions", category: "Healing", icon: "🌟", desc: "Individual healing sessions that have transformed the lives of participants across the USA." },
  { id: "3", title: "Community Satsang — New York", category: "Community", icon: "🗽", desc: "Monthly gatherings bringing together the NYC spiritual community." },
  { id: "4", title: "Dream Wisdom Workshop", category: "Workshops", icon: "🌙", desc: "A day-long immersion into the science and spirituality of dreams." },
  { id: "5", title: "Aekam Magazine Launch", category: "Publications", icon: "📖", desc: "The launch of our quarterly publication, now distributed to 5,000+ readers worldwide." },
  { id: "6", title: "Youth Meditation Program", category: "Community", icon: "🧒", desc: "Bringing mindfulness and meditation practices to schools across North Texas." },
];

const CATEGORIES = ["All", "Events", "Healing", "Community", "Workshops", "Publications"];

export function PortfolioPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [lightbox, setLightbox] = useState<typeof PORTFOLIO_ITEMS[0] | null>(null);

  const filtered = activeCategory === "All"
    ? PORTFOLIO_ITEMS
    : PORTFOLIO_ITEMS.filter((i) => i.category === activeCategory);

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Our Work</p>
          <h1 className="display-2">Portfolio</h1>
          <p className="hero__body" style={{ maxWidth: "540px", margin: "0 auto" }}>
            A glimpse into the transformative events, programs, and publications that define the
            Aekam movement.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Category filter */}
          <div className="blog-cats" style={{ marginBottom: "2rem" }}>
            {CATEGORIES.map((c) => (
              <button
                key={c}
                className={`events-tag-chip ${activeCategory === c ? "active" : ""}`}
                onClick={() => setActiveCategory(c)}
              >
                {c}
              </button>
            ))}
          </div>

          {/* Masonry-style grid */}
          <div className="portfolio-grid">
            {filtered.map((item) => (
              <div
                key={item.id}
                className="portfolio-card"
                onClick={() => setLightbox(item)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && setLightbox(item)}
              >
                <div className="portfolio-card__image">{item.icon}</div>
                <div className="portfolio-card__body">
                  <div className="portfolio-card__cat">{item.category}</div>
                  <h3 className="portfolio-card__title">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="modal-overlay" onClick={() => setLightbox(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "480px" }}>
            <div className="modal-box__header">
              <h2>{lightbox.title}</h2>
              <button className="modal-box__close" onClick={() => setLightbox(null)}>✕</button>
            </div>
            <div style={{ textAlign: "center", fontSize: "4rem", margin: "1.5rem 0" }}>{lightbox.icon}</div>
            <p style={{ color: "var(--c-ink-75)", lineHeight: "1.7" }}>{lightbox.desc}</p>
            <div className="badge badge--brand" style={{ marginTop: "1rem" }}>{lightbox.category}</div>
          </div>
        </div>
      )}
    </>
  );
}
